import $ from 'jquery'

if (document.getElementById('page-contact')) {
  page()
}

function page() {
  const $button = $('.auto-zipaddr')
  if ($button.length) {
    $button.on('click', () => {
      const zip = $('#zip').val()
      const url = `https://zipcloud.ibsnet.co.jp/api/search?zipcode=${zip}`
      $.ajax({
        url,
        dataType: 'jsonp',
        jsonpCallback: 'myCallback', // オプションでコールバック関数名を指定
        success: function (data) {
          const { status, results } = data
          if (status == 200) {
            $('#pref').val(results[0].address1)
            $('#city').val(results[0].address2)
            $('#area').val(results[0].address3)
          }
        },
        error: function (jqXHR, textStatus, errorThrown) {
          // console.error('JSONPリクエストに失敗しました。', textStatus, errorThrown)
        },
      })
    })
  }

  if ($('#example-name-plate').length) {
    $('#example-name-plate').append(
      $(`
      <div class="orderExample">
        <div class="orderExample__frame">
          <div class="orderExample__head">
            <p class="orderExample__headTitle">ネームプレート刻印 例</p>
            <p class="orderExample__headText">ご入力された情報をもとに、こちらで構成いたします</p>
          </div>
          <div class="orderExample__body">
            <div class="orderExample__image orderExample__image--name"></div>
            <ol class="orderExample__list">
              <li><span data-no="1"></span><p>お名前</p></li>
              <li><span data-no="2"></span><p>所属先名<sup>※</sup></p></li>
              <li><span data-no="3"></span><p>所属期間（西暦）<sup>※</sup></p></li>
              <li><span data-no="4"></span><p>ポジション名<sup>※</sup></p></li>
              <li><span data-no="5"></span><p>番号<sup>※</sup>（背番号、ゼッケンナンバーなど）</p></li>
              <li><span data-no="6"></span><p>その他<sup>※</sup>（大会名・成績・記録・会場名など）</p></li>
            </ol>
          </div>
          <p class="orderExample__listNote"><span>(※)</span>記載事項がない場合には空欄でも構いません</p>
        </div>
        <p class="orderExample__note">※ここに記入した文字をそのまま刻印させていただきます。スペル・表記にお間違いがないか必ずご確認ください。</p>
      </div>
      `)
    )
  }

  if ($('#example-logo-plate').length) {
    $('#example-logo-plate').append(
      $(`
      <div class="orderExample">
        <div class="orderExample__frame">
          <div class="orderExample__head">
            <p class="orderExample__headTitle">ロゴプレート刻印 例</p>
            <p class="orderExample__headText">ご入力された情報をもとに、こちらで構成いたします</p>
          </div>
          <div class="orderExample__body orderExample__body--logo">
            <div class="orderExample__image orderExample__image--logo"></div>
            <ol class="orderExample__list">
              <li><span data-no="1"></span><p>チームのロゴなど</p></li>
              <li><span data-no="2"></span><p>チームの歴史（創設年・過去の功績）、スローガンなど</p></li>
            </ol>
          </div>
        </div>
        <p class="orderExample__note">※ここに記入した文字をそのまま刻印させていただきます。スペル・表記にお間違いがないか必ずご確認ください。</p>
      </div>
      `)
    )
  }
}
